import z from "zod";
import { CatalogDomain } from "./enums/CatalogDomain";
import { CatalogOverridableField } from "./enums/CatalogOverridableField";

export const CatalogDomainPolicyScheme = z.object({
  storesCanCreateLocal: z.boolean().optional(),
  overridableFields: z.array(z.enum(CatalogOverridableField)).optional(),
});

export const CatalogPolicyScheme = z.object({
  products: CatalogDomainPolicyScheme,
  productGroups: CatalogDomainPolicyScheme,
  modifiers: CatalogDomainPolicyScheme,
  modifierGroups: CatalogDomainPolicyScheme,
  courses: CatalogDomainPolicyScheme,
  units: CatalogDomainPolicyScheme,
  suppliers: CatalogDomainPolicyScheme,
  extraProductFields: CatalogDomainPolicyScheme,
  bookkeepingAccounts: CatalogDomainPolicyScheme,
  prepStations: CatalogDomainPolicyScheme,
  offers: CatalogDomainPolicyScheme,
  productPages: CatalogDomainPolicyScheme,
  layouts: CatalogDomainPolicyScheme,
});

export const CatalogPolicyOverridesScheme = CatalogPolicyScheme.partial();

export type CatalogDomainPolicy = z.infer<typeof CatalogDomainPolicyScheme>;
export type CatalogPolicy = z.infer<typeof CatalogPolicyScheme>;
export type CatalogPolicyOverrides = z.infer<
  typeof CatalogPolicyOverridesScheme
>;

export const defaultDomainPolicy: CatalogDomainPolicy = {
  storesCanCreateLocal: true,
  overridableFields: [],
};

export const defaultCatalogPolicy: CatalogPolicy = {
  products: defaultDomainPolicy,
  productGroups: defaultDomainPolicy,
  modifiers: defaultDomainPolicy,
  modifierGroups: defaultDomainPolicy,
  courses: defaultDomainPolicy,
  units: defaultDomainPolicy,
  suppliers: defaultDomainPolicy,
  extraProductFields: defaultDomainPolicy,
  bookkeepingAccounts: defaultDomainPolicy,
  prepStations: defaultDomainPolicy,
  offers: defaultDomainPolicy,
  productPages: defaultDomainPolicy,
  layouts: defaultDomainPolicy,
};

export const catalogDomainPolicyKey: Record<
  CatalogDomain,
  keyof CatalogPolicy
> = {
  [CatalogDomain.PRODUCTS]: "products",
  [CatalogDomain.PRODUCT_GROUPS]: "productGroups",
  [CatalogDomain.MODIFIERS]: "modifiers",
  [CatalogDomain.MODIFIER_GROUPS]: "modifierGroups",
  [CatalogDomain.COURSES]: "courses",
  [CatalogDomain.UNITS]: "units",
  [CatalogDomain.SUPPLIERS]: "suppliers",
  [CatalogDomain.EXTRA_PRODUCT_FIELDS]: "extraProductFields",
  [CatalogDomain.BOOKKEEPING_ACCOUNTS]: "bookkeepingAccounts",
  [CatalogDomain.PREP_STATIONS]: "prepStations",
  [CatalogDomain.OFFERS]: "offers",
  [CatalogDomain.PRODUCT_PAGES]: "productPages",
  [CatalogDomain.LAYOUTS]: "layouts",
};
